import React from 'react';
import { BeforePrimaryToolbarWrapper } from './ui/BeforePrimaryToolbarWrapper';
export var beforePrimaryToolbarPlugin = function beforePrimaryToolbarPlugin(_ref) {
  var _api$primaryToolbar;
  var api = _ref.api,
    props = _ref.config;
  var primaryToolbarComponent = function primaryToolbarComponent() {
    return /*#__PURE__*/React.createElement(BeforePrimaryToolbarWrapper, {
      beforePrimaryToolbarComponents: props === null || props === void 0 ? void 0 : props.beforePrimaryToolbarComponents
    });
  };
  api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
    name: 'beforePrimaryToolbar',
    component: primaryToolbarComponent
  });
  return {
    name: 'beforePrimaryToolbar',
    primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
  };
};